import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookie from 'js-cookie';


const Logout = ({onLogout}) => {
    const navigate = useNavigate();

    useEffect(() => {
      Cookie.remove('token');
      navigate('/');
      window.location.reload();
    }, [navigate, onLogout]);

    return (
      <div>
        <p>Cerrando sesión...</p>
      </div>
    );
  };

  export default Logout;